import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import type {
  FlexibilityPrices,
  RateCards,
  RateCardsParams,
  SupplierAllocation,
  SupplierAllocationsParams,
  SupplierAllocationsUpdate,
  SupplierBlend,
  SupplierBlendSave,
  SupplierGroupTemplate,
  SupplierGroupTemplateSave,
  SupplierManagedAllocationsUpdate,
} from '@ps/survey-utils';

import { SupplierApi } from '../../api/supplier/supplier.api';

@Injectable({ providedIn: 'root' })
export class SupplierService {
  private readonly _api = inject(SupplierApi);

  public flexibilityPriceParams(
    surveyId: number,
  ): Observable<FlexibilityPrices> {
    return this._api.flexibilityPriceParams(surveyId);
  }

  public blends(locale: string): Observable<SupplierBlend[]> {
    return this._api.blends(locale);
  }

  public groupTemplates(): Observable<SupplierGroupTemplate[]> {
    return this._api.groupTemplates();
  }

  public allocations(
    surveyId: number,
    params: SupplierAllocationsParams,
  ): Observable<SupplierAllocation[]> {
    return this._api.allocations(surveyId, params);
  }

  public updateAllocations(
    surveyId: number,
    update: SupplierAllocationsUpdate,
  ): Observable<SupplierAllocation[]> {
    return this._api.updateAllocations(surveyId, update);
  }

  public updateManagedAllocations(
    surveyId: number,
    update: SupplierManagedAllocationsUpdate,
  ): Observable<SupplierAllocation[]> {
    return this._api.updateManagedAllocations(surveyId, update);
  }

  public saveGroupTemplate(data: SupplierGroupTemplateSave): Observable<void> {
    return this._api.saveGroupTemplate(data);
  }

  public saveBlend(data: SupplierBlendSave): Observable<SupplierBlend> {
    return this._api.saveBlend(data);
  }

  public rateCards(params: RateCardsParams): Observable<RateCards> {
    return this._api.rateCards(params);
  }
}
